<template>
    <v-expansion-panels
        :value="value"
        multiple
        accordion
        @change="$emit('change', $event)"
    >
        <ExpansionPanel
            v-for="(item, index) in items"
            :key="index"
            :item="item"
            :title="title"
            :has-error="errors && ValidationModule.indexHasErrors(errors, index)"
        >
            <slot :name="getItemSlotName(item.expandableKey)" :item="item" :index="index">
                <slot :item="item" :index="index" />
            </slot>
            <template v-slot:actions>
                <slot :name="getActionsSlotName(item.expandableKey)" :item="item">
                    <slot name="actions" :item="item" />
                </slot>
            </template>
        </ExpansionPanel>
    </v-expansion-panels>
</template>

<script>
import { $t } from "@/i18n";
import ExpansionPanel from "@/components/ExpansionPanels/ExpansionPanel";
import {onMounted, ref, watch} from "@vue/composition-api";
import ValidationModule from "@/modules/validation/validation"

export default {
    name: "ExpansionPanels",
    components: {
        ExpansionPanel
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        title: {
            type: Function,
            default: null
        },
        value: {
            type: Array,
            default: null
        },
        errors: {
            type: Object,
            default: null
        }
    },
    setup(props) {
        const getItemSlotName = (name) => {
            return `item.${name}`
        }

        const getActionsSlotName = (name) => {
            return `actions.${name}`
        }

        return {
            getItemSlotName,
            getActionsSlotName,
            ValidationModule
        };
    }
};
</script>

